export function normalizeTurkishMobile(value?: string | null) {
  let digits = String(value ?? "").replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.startsWith("90")) digits = digits.slice(2);
  if (digits.startsWith("0")) digits = digits.slice(1);
  return /^5\d{9}$/.test(digits) ? `0${digits}` : null;
}

export function isValidTurkishMobile(value?: string | null) {
  return String(value ?? "").trim() === "" || normalizeTurkishMobile(value) !== null;
}

export function smsPhoneState(value?: string | null) {
  if (!String(value ?? "").trim()) return "missing" as const;
  return normalizeTurkishMobile(value) ? "valid" as const : "invalid" as const;
}
